import Cookie from 'js-cookie'
import uuid from 'react-uuid'

export function getCookie(key: string) {
   return Cookie.get(key)
}

export const removeCookie = (keyName: string): void => {
   Cookie.remove(keyName, { path: '/' })
}

export function setCookie(key: string, value: string, expiryInDays = 30) {
   if (
      process.env['NODE_ENV'] === 'development' ||
      window.location.hostname === 'localhost'
   ) {
      Cookie.set(key, value, {
         expires: expiryInDays,
         path: '/'
      })
   } else {
      Cookie.set(key, value, {
         expires: expiryInDays,
         path: '/',
         secure: true
      })
   }
}
export const DEVICE_ID_KEY = 'deviceId'
export const IS_PRODUCTION_SELECTED = 'isProdSelected'
export const BASE_SERVER_URL_KEY = 'base_url'
export const GRAPHQL_SERVER_URL_KEY = 'graphql_url'

export function setBaseUrl(baseUrl: string) {
   window.localStorage.setItem(BASE_SERVER_URL_KEY, baseUrl)
}

export function getBaseUrl() {
   return window.localStorage.getItem(BASE_SERVER_URL_KEY)
}

export function setGraphQLUrl(graphQLUrl: string): void {
   window.localStorage.setItem(GRAPHQL_SERVER_URL_KEY, graphQLUrl)
}

export function getGraphQLUrl(): string | null {
   return window.localStorage.getItem(GRAPHQL_SERVER_URL_KEY)
}

export function setDeviceId(deviceId: string) {
   setCookie(DEVICE_ID_KEY, deviceId)
}

export function removeDeviceId() {
   removeCookie(DEVICE_ID_KEY)
}

export function getDeviceId() {
   const deviceId = getCookie(DEVICE_ID_KEY)
   if (deviceId) {
      return deviceId
   } else {
      const deviceId = uuid()
      setDeviceId(deviceId)
      return deviceId
   }
}
